package com.rainbowclubs.rainbow.domain.use_cases.club

import com.rainbowclubs.rainbow.data.cache.ClubCache

class GetSelectedClubIdUseCase(
    private val clubCache: ClubCache,
) {
    operator fun invoke(): String? {
        return clubCache.selectedClub
    }
}
